// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const contracts_1 = require("./ledger/backend/contracts");
const enclave_1 = require("./enclave");
const ledger_1 = require("./ledger");
const backend_1 = require("./ledger/backend");
const utils_1 = require("./utils");
const ethereumOnChainQuerier_1 = require("./ledger/backend/ethereumOnChainQuerier");
const _erdstall_1 = require("./");
class Client {
    constructor(provider, encConn) {
        this.provider = provider;
        if (encConn instanceof URL)
            this.enclaveConn = enclave_1.Enclave.dial(encConn);
        else
            this.enclaveConn = encConn;
        this.erdstallEventHandlerCache = new utils_1.EventCache();
        this.erdstallOneShotHandlerCache = new utils_1.OneShotEventCache();
        this.tokenProvider = new backend_1.TokenFetcher();
        this.onChainQuerier = new ethereumOnChainQuerier_1.EthereumOnChainQuerier(this.provider);
    }
    erdstall() {
        return this.erdstallConn.erdstall();
    }
    getNftMetadata(token, id, useCache) {
        if (!this.erdstallConn) {
            throw new Error("client uninitialized");
        }
        return this.erdstallConn.getNftMetadata(token, id, useCache);
    }
    on_internal(ev, cb) {
        return this.enclaveConn.on_internal(ev, cb);
    }
    off_internal(ev, cb) {
        return this.enclaveConn.off_internal(ev, cb);
    }
    on(ev, cb) {
        if (ledger_1.isLedgerEvent(ev)) {
            if (this.erdstallConn) {
                this.erdstallConn.on(ev, cb);
            }
            else {
                this.erdstallEventHandlerCache.set(ev, cb);
            }
        }
        else if (enclave_1.isEnclaveEvent(ev)) {
            return this.enclaveConn.on(ev, cb);
        }
        else {
            const exhaustiveCheck = ev;
            throw new Error(`unhandled eventtype: ${exhaustiveCheck}`);
        }
    }
    once_internal(ev, cb) {
        return this.enclaveConn.once_internal(ev, cb);
    }
    once(ev, cb) {
        if (ledger_1.isLedgerEvent(ev)) {
            if (this.erdstallConn) {
                this.erdstallConn.once(ev, cb);
            }
            else {
                this.erdstallOneShotHandlerCache.set(ev, cb);
            }
        }
        else if (enclave_1.isEnclaveEvent(ev)) {
            return this.enclaveConn.once(ev, cb);
        }
        else {
            // Happens statically in TS and also throws an error when used as a JS lib.
            const exhaustiveCheck = ev;
            throw new Error(`unhandled eventtype: ${exhaustiveCheck}`);
        }
    }
    off(ev, cb) {
        if (ledger_1.isLedgerEvent(ev)) {
            if (!this.erdstallConn) {
                return;
            }
            this.erdstallConn.off(ev, cb);
        }
        else if (enclave_1.isEnclaveEvent(ev)) {
            return this.enclaveConn.off(ev, cb);
        }
        else {
            // Happens statically in TS and also throws an error when used as a JS lib.
            const exhaustiveCheck = ev;
            throw new Error(`unhandled eventtype: ${exhaustiveCheck}`);
        }
    }
    removeAllListeners() {
        this.enclaveConn.removeAllListeners();
        this.erdstallConn?.removeAllListeners();
        this.erdstallEventHandlerCache.clear();
        this.erdstallOneShotHandlerCache.clear();
    }
    async subscribe(who) {
        return this.enclaveConn.subscribe(who);
    }
    async getAccount(who) {
        return (await this.enclaveConn.getAccount(who)).account;
    }
    initialize(timeout) {
        return new Promise((resolve, reject) => {
            const rejectTimeout = setTimeout(reject, timeout ? timeout : 15000);
            this.enclaveConn.once("error", reject);
            this.enclaveConn.once("config", (config) => {
                const erdstall = contracts_1.Erdstall__factory.connect(config.contract.toString(), this.provider);
                this.erdstallConn = new ledger_1.LedgerWriteConn(erdstall, this.tokenProvider);
                if (this instanceof _erdstall_1.Session) {
                    this.receiptDispatcher.erdstallConn = this.erdstallConn;
                }
                for (const [ev, cbs] of this.erdstallEventHandlerCache) {
                    cbs.forEach((cb) => {
                        this.erdstallConn.on(ev, cb);
                    });
                }
                for (const [ev, cbs] of this.erdstallOneShotHandlerCache) {
                    cbs.forEach((cb) => {
                        this.erdstallConn.once(ev, cb);
                    });
                }
                this.erdstallOneShotHandlerCache.clear();
                clearTimeout(rejectTimeout);
                this.enclaveConn.off("error", reject);
                resolve();
            });
            this.enclaveConn.connect();
        });
    }
}
exports.Client = Client;
//# sourceMappingURL=client.js.map